import { render } from "./FilterHistoric.vue?vue&type=template&id=1f1ab9eb"
import script from "./FilterHistoric.vue?vue&type=script&lang=js"
export * from "./FilterHistoric.vue?vue&type=script&lang=js"
script.render = render

export default script